module.exports = __webpack_public_path__ + "wpicons.c505c78d0053ee9becc2.eot";


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/assets/fonts/wpicons.eot
// module id = ../../../../../src/assets/fonts/wpicons.eot
// module chunks = 2